import React, { useContext } from "react";
// contexts
import { CartContext } from "@cart-client/contexts/CartContext";
// components
import { ReviewItemListCard } from "@swiggy-private/dls-web-recipe-common-web/dist/components/ReviewItemListCard";
import { useGetGiftingCartItemsRenderingProps } from "@cart-client/hooks/useGetGiftingCartItemsRenderingProps";
import { GiftingIMGiftBagHalfcard } from "@swiggy-private/cart-ui";
// utils
import { isEmpty } from "@swiggy-private/js-utils";
// types
import { GiftingCartState } from "@cart-client/reducers/GiftingCartReducer";
// styles
import { ReviewItemWrapper } from "./styles";
// hooks
import { useGetGiftBagAnalytics } from "./hooks/useGetGiftBagAnalytics";

export const ReviewItemListWrapper = () => {
    const { cartState } = useContext(CartContext);
    const { reviewedCart } = cartState as GiftingCartState;
    const { foodCartItems, imCartItems } = reviewedCart?.data || {};
    const analyticsEvents = useGetGiftBagAnalytics({
        popupDetails: reviewedCart?.data?.imGiftBag?.widgetInfo?.popupDetails,
        reviewedCart: reviewedCart?.data,
    });
    /**
     * we will need to build the review item list in following order -
     * 1. OOS items
     * 2. Food/IM subcart based on SLA
     * 3. IM/Food subcart based on SLA
     */
    const {
        propsForOOSItemList,
        propsForAllInStockItemsCarts,
        oosItemCount,
        availItemCount,
        giftBagSelectionHalfCardProps,
    } = useGetGiftingCartItemsRenderingProps();

    const areOOSItemsPresent = oosItemCount > 0 && !isEmpty(propsForOOSItemList);
    const areInStockItemsPresent = availItemCount > 0 && !isEmpty(propsForAllInStockItemsCarts);

    if (isEmpty(foodCartItems?.items) && isEmpty(imCartItems)) {
        return null;
    }

    if (!areOOSItemsPresent && !areInStockItemsPresent) {
        return null;
    }

    return (
        <>
            {areOOSItemsPresent && propsForOOSItemList && (
                <ReviewItemWrapper reduceTopPadding={areOOSItemsPresent}>
                    <ReviewItemListCard {...propsForOOSItemList} />
                </ReviewItemWrapper>
            )}
            {/** used for food/IM subcart based on SLA */}
            {areInStockItemsPresent &&
                propsForAllInStockItemsCarts.map((propsForInStockItems, index) => {
                    const isFirstItem = index == 0;
                    return (
                        <ReviewItemWrapper key={index} reduceTopPadding={isFirstItem && !areOOSItemsPresent}>
                            <ReviewItemListCard {...propsForInStockItems} />
                        </ReviewItemWrapper>
                    );
                })}
            {/** used for gift bag option selection for IM items */}
            {!isEmpty(giftBagSelectionHalfCardProps) && (
                <GiftingIMGiftBagHalfcard {...giftBagSelectionHalfCardProps} {...analyticsEvents} />
            )}
        </>
    );
};
